// extracted by mini-css-extract-plugin
export var actualProgress = "ProgressBar-module--actualProgress--cc5hS";
export var isBlue = "ProgressBar-module--isBlue--VXixi";
export var progressBar = "ProgressBar-module--progressBar--DtYIO";